//Global Config For Every Jwplayer/VideoPlayer instance
//Pass object as config prop when creating a player
export const jwPlayerConfig = {
    licenseKey: 'IY8CTVBuF9v2BIsdlWWyqQBqBDoqtTh7EUWo42TOcTs',
    hostedJwPlayerScript: 'https://cdn.skyelearning.com/js/jwplayer8/jwplayer.js',
    playerConfig: {
        width: '100%',
        aspectratio: '16:9'
    }
};

/**
 * Config Properties For Each Video
 */


//Business Video
export const certDifferenceVideo = {
    playlist: [{
        file: 'https://cdn.skyelearning.com/static/videos/CertificatesVsCertificationsVideo_Final.mp4',
        image: 'https://cdn.skyelearning.com/static/videos/SkyePromo_Final_Poster_Compressed.png',
        tracks: [{
          file: 'https://cdn.skyelearning.com/static/videos/CertificatesVsCertificationsVideo_Final.xml',
          label: 'English',
          kind: 'captions',
            'default': true
        }],
    }]
};